<template>
  <section class="section container">
    <div class="title is-3 has-text-centered">{{ $t("loan management") }}</div>

    <!-- Dashboard Overview -->
    <div class="columns is-multiline mb-6">
      <!-- KPI Cards -->
      <div class="column is-3">
        <div class="box has-background-success-dark">
          <div class="level">
            <div class="level-left">
              <div>
                <p class="heading">{{ $t("total portfolio") }}</p>
                <p class="title is-4">${{ totalPortfolio.toLocaleString() }}</p>
              </div>
            </div>
            <div class="level-right">
              <span class="icon is-large has-text-success">
                <i class="fa fa-dollar-sign fa-2x"></i>
              </span>
            </div>
          </div>
        </div>
      </div>

      <div class="column is-3">
        <div class="box has-background-info-dark">
          <div class="level">
            <div class="level-left">
              <div>
                <p class="heading">{{ $t("active loans") }}</p>
                <p class="title is-4">{{ activeLoans }}</p>
              </div>
            </div>
            <div class="level-right">
              <span class="icon is-large has-text-info">
                <i class="fa fa-hand-holding-usd fa-2x"></i>
              </span>
            </div>
          </div>
        </div>
      </div>

      <div class="column is-3">
        <div class="box has-background-warning-dark">
          <div class="level">
            <div class="level-left">
              <div>
                <p class="heading">{{ $t("pending applications") }}</p>
                <p class="title is-4">{{ pendingApplications }}</p>
              </div>
            </div>
            <div class="level-right">
              <span class="icon is-large has-text-warning">
                <i class="fa fa-file-alt fa-2x"></i>
              </span>
            </div>
          </div>
        </div>
      </div>

      <div class="column is-3">
        <div class="box has-background-danger-dark">
          <div class="level">
            <div class="level-left">
              <div>
                <p class="heading">{{ $t("overdue payments") }}</p>
                <p class="title is-4">{{ overduePayments }}</p>
              </div>
            </div>
            <div class="level-right">
              <span class="icon is-large has-text-danger">
                <i class="fa fa-exclamation-triangle fa-2x"></i>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Charts Section -->
    <div class="columns is-multiline" v-show="false">
      <div class="column is-8">
        <div class="box">
          <h4 class="title is-5">{{ $t("loan portfolio") }}</h4>
          <canvas ref="portfolioChart" width="400" height="200"></canvas>
        </div>
      </div>

      <div class="column is-4">
        <div class="box">
          <h4 class="title is-5">{{ $t("payment trends") }}</h4>
          <canvas ref="paymentsChart" width="200" height="200"></canvas>
        </div>
      </div>
    </div>

    <!-- Action Grid -->
    <!-- <div class="title is-4 has-text-centered mb-4">
      {{ $t("quick actions") }}
    </div> -->
    <div class="grid is-col-min-10">
      <div class="cell" @click="go_applications">
        <div class="card">
          <div class="card-image">
            <figure class="image is-64x64 m-auto py-4">
              <img
                src="https://marketplace.canva.com/er2Z4/MAGRpEer2Z4/1/tl/canva-revision-documentation-icon-MAGRpEer2Z4.png"
              />
            </figure>
          </div>
          <div class="card-content px-0">
            <div class="media">
              <div class="media-content">
                <p class="title is-5 has-text-centered">
                  {{ $t("loan applications") }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="cell" @click="go_customers">
        <div class="card">
          <div class="card-image">
            <figure class="image is-64x64 m-auto py-4">
              <img
                src="https://cdn-icons-png.flaticon.com/512/7909/7909958.png"
              />
            </figure>
          </div>
          <div class="card-content px-0">
            <div class="media">
              <div class="media-content">
                <p class="title is-5 has-text-centered">
                  {{ $t("customers") }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="cell" @click="go_loans">
        <div class="card">
          <div class="card-image">
            <figure class="image is-64x64 m-auto py-4">
              <img
                src="https://cdn-icons-png.freepik.com/256/9881/9881952.png?semt=ais_white_label"
              />
            </figure>
          </div>
          <div class="card-content px-0">
            <div class="media">
              <div class="media-content">
                <p class="title is-5 has-text-centered">
                  {{ $t("active loans") }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="cell" @click="go_loan_types">
        <div class="card">
          <div class="card-image">
            <figure class="image is-64x64 m-auto py-4">
              <img
                src="https://cdn-icons-png.flaticon.com/256/3135/3135706.png"
              />
            </figure>
          </div>
          <div class="card-content px-0">
            <div class="media">
              <div class="media-content">
                <p class="title is-5 has-text-centered">
                  {{ $t("loan types") }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="cell" @click="go_payments">
        <div class="card">
          <div class="card-image">
            <figure class="image is-64x64 m-auto py-4">
              <img
                src="https://cdn-icons-png.flaticon.com/512/1019/1019607.png"
              />
            </figure>
          </div>
          <div class="card-content px-0">
            <div class="media">
              <div class="media-content">
                <p class="title is-5 has-text-centered">
                  {{ $t("payments") }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- <div class="cell" @click="go_schedules">
        <div class="card">
          <div class="card-image">
            <figure class="image is-64x64 m-auto py-4">
              <img
                src="https://cdn-icons-png.flaticon.com/512/10319/10319982.png"
              />
            </figure>
          </div>
          <div class="card-content px-0">
            <div class="media">
              <div class="media-content">
                <p class="title is-5 has-text-centered">
                  {{ $t("payment schedules") }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div> -->
    </div>

    <!-- Recent Activity Section -->
    <div class="columns is-multiline mt-6">
      <div class="column is-6">
        <div class="box">
          <h4 class="title is-5">{{ $t("recent applications") }}</h4>
          <div class="table-container">
            <table class="table is-fullwidth is-striped">
              <thead>
                <tr>
                  <th>{{ $t("applicant name") }}</th>
                  <th>{{ $t("amount") }}</th>
                  <th>{{ $t("status") }}</th>
                  <!-- <th>{{ $t("actions") }}</th> -->
                </tr>
              </thead>
              <tbody>
                <tr v-for="app in recentApplications" :key="app.uuid">
                  <td>
                    {{ app.applicant_first_name }} {{ app.applicant_last_name }}
                  </td>
                  <td>${{ app.requested_amount.toLocaleString() }}</td>
                  <td>
                    <span class="tag" :class="getStatusClass(app.status)">
                      {{ $t(app.status) }}
                    </span>
                  </td>
                  <!-- <td>
                    <button
                      class="button is-small is-success"
                      v-if="app.status === 'pending'"
                      @click="approveApplication(app.uuid)"
                    >
                      {{ $t("approve") }}
                    </button>
                    <button
                      class="button is-small is-danger ml-1"
                      v-if="app.status === 'pending'"
                      @click="rejectApplication(app.uuid)"
                    >
                      {{ $t("reject") }}
                    </button>
                  </td> -->
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div class="column is-6">
        <div class="box">
          <h4 class="title is-5">{{ $t("upcoming payments") }}</h4>
          <div class="table-container">
            <table class="table is-fullwidth is-striped">
              <thead>
                <tr>
                  <th>{{ $t("loan number") }}</th>
                  <th>{{ $t("due date") }}</th>
                  <th>{{ $t("amount") }}</th>
                  <th>{{ $t("status") }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="payment in upcomingPayments" :key="payment.uuid">
                  <td>{{ payment.loan.loan_number }}</td>
                  <td>{{ formatDate(payment.due_date) }}</td>
                  <td>${{ payment.total_amount.toLocaleString() }}</td>
                  <td>
                    <span class="tag" :class="getStatusClass(payment.status)">
                      {{ $t(payment.status) }}
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Chart from "chart.js/auto";
import moment from "moment";
import { get, post, error_message, format_currency } from "@/utils";

export default {
  name: "LoanIndex",
  data() {
    return {
      totalPortfolio: 0,
      activeLoans: 0,
      pendingApplications: 0,
      overduePayments: 0,
      recentApplications: [],
      upcomingPayments: [],
      portfolioChart: null,
      paymentsChart: null,
    };
  },
  mounted() {
    this.loadDashboardData();
    this.initCharts();
  },
  methods: {
    async loadDashboardData() {
      try {
        // Load KPI data
        const response = await get("/loan/dashboard/stats");
        this.totalPortfolio = response.total_portfolio || 0;
        this.activeLoans = response.active_loans || 0;
        this.pendingApplications = response.pending_applications || 0;
        this.overduePayments = response.overdue_payments || 0;
        this.recentApplications = response.recent_applications || [];
        this.upcomingPayments = response.upcoming_payments || [];
      } catch (error) {
        console.error("Error loading dashboard data:", error);
        error_message(error);
      }
    },

    initCharts() {
      // Portfolio Chart
      const portfolioCtx = this.$refs.portfolioChart.getContext("2d");
      this.portfolioChart = new Chart(portfolioCtx, {
        type: "line",
        data: {
          labels: ["Jan", "Feb", "Mar", "Apr", "May", "Jun"],
          datasets: [
            {
              label: "Portfolio Value",
              data: [65000, 75000, 85000, 95000, 105000, 115000],
              borderColor: "#3273dc",
              backgroundColor: "rgba(50, 115, 220, 0.1)",
              tension: 0.4,
            },
          ],
        },
        //   options: {
        //     responsive: true,
        //     maintainAspectRatio: false,
        //   },
      });

      // Payments Chart
      const paymentsCtx = this.$refs.paymentsChart.getContext("2d");
      this.paymentsChart = new Chart(paymentsCtx, {
        type: "doughnut",
        data: {
          labels: ["On Time", "Late", "Overdue"],
          datasets: [
            {
              data: [70, 20, 10],
              backgroundColor: ["#48c774", "#ffdd57", "#f14668"],
            },
          ],
        },
        //   options: {
        //     responsive: true,
        //     maintainAspectRatio: false,
        //   },
      });
    },

    go_applications() {
      this.$router.push("/loan/application");
    },

    go_loans() {
      this.$router.push("/loan/loans");
    },

    go_loan_types() {
      this.$router.push("/loan/type");
    },

    go_payments() {
      this.$router.push("/loan/payment");
    },

    go_schedules() {
      this.$router.push("/loan/schedule");
    },

    getStatusClass(status) {
      const statusClasses = {
        pending: "is-warning",
        approved: "is-success",
        rejected: "is-danger",
        active: "is-info",
        paid: "is-success",
        overdue: "is-danger",
      };
      return statusClasses[status] || "is-dark";
    },

    formatDate(date) {
      return moment(date).format("MMM DD, YYYY");
    },

    async approveApplication(uuid) {
      try {
        await post("/loan/application", {
          uuid: uuid,
          status: "approved",
        });
        this.loadDashboardData();
      } catch (error) {
        console.error("Error approving application:", error);
        error_message(error);
      }
    },

    async rejectApplication(uuid) {
      try {
        await post("/loan/application", {
          uuid: uuid,
          status: "rejected",
        });
        this.loadDashboardData();
      } catch (error) {
        console.error("Error rejecting application:", error);
        error_message(error);
      }
    },
    go_customers() {
      this.$router.push("/loan/customer");
    },
  },

  beforeDestroy() {
    if (this.portfolioChart) {
      this.portfolioChart.destroy();
    }
    if (this.paymentsChart) {
      this.paymentsChart.destroy();
    }
  },
};
</script>

<style scoped>
.grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 1rem;
}

.cell {
  cursor: pointer;
  transition: transform 0.2s;
}

.cell:hover {
  transform: translateY(-2px);
}

.card {
  height: 100%;
}
</style>
